// extracted by mini-css-extract-plugin
export default {"parentComponent":"FooterButton_parentComponent__f1WuT","hoverComponent":"FooterButton_hoverComponent__ZUXdl","active":"FooterButton_active__SlKhb"};